import BrandService from "@/store/services/brand.service.js"

export default {
  namespaced: true,
  state: {
    availableBrands: [],
    selectedBrandName: "",
    selectedBrandId: 0,
  },
  getters: {
    getAvailableBrands: state => state.availableBrands,
    getSelectedBrandName: state => state.selectedBrandName,
    getSelectedBrandId: state => state.selectedBrandId,
    getBrandById: state => brand_id => state.availableBrands.find(brand => brand.id === brand_id)
  },
  mutations: {
    SET_AVAILABLE_BRANDS (state, data) {
      state.availableBrands = data
    },
    SET_SELECTED_BRAND_NAME (state, data) {
      state.selectedBrandName = data
    },
    SET_SELECTED_BRAND_ID (state, data) {
      state.selectedBrandId = data
    },
  },
  actions: {
    loadCompanyBrands ({ commit }, company_id) {
      return BrandService.list({ company_profile: company_id }).then((response) => {
        commit('SET_AVAILABLE_BRANDS', response.data)
      })
    },
    loadBrandsMainData ({ dispatch }, company_id) {
      return Promise.all([
        dispatch('loadCompanyBrands', company_id)
      ])
    }
  }
};